import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { storageManager } from '../utils/storage';

interface ReadOnlyContextType {
  isReadOnly: boolean;
}

const defaultValue: ReadOnlyContextType = {
  isReadOnly: false,
};

const ReadOnlyContext = createContext<ReadOnlyContextType>(defaultValue);

interface ReadOnlyProviderProps {
  children: ReactNode;
}

export const ReadOnlyProvider: React.FC<ReadOnlyProviderProps> = ({ children }) => {
  const [isReadOnly, setIsReadOnly] = useState<boolean>(storageManager.isReadOnlyMode());

  useEffect(() => {
    // 初始检查
    setIsReadOnly(storageManager.isReadOnlyMode());
    
    // 监听上下文变更事件，更新只读状态
    const handleContextChange = () => {
      console.log("ReadOnlyContext: Context changed, updating read-only status...");
      setIsReadOnly(storageManager.isReadOnlyMode());
    };
    
    window.addEventListener('contextChange', handleContextChange);
    
    return () => {
      window.removeEventListener('contextChange', handleContextChange);
    };
  }, []);

  return (
    <ReadOnlyContext.Provider value={{ isReadOnly }}>
      {children}
    </ReadOnlyContext.Provider>
  );
};

export const useReadOnly = () => useContext(ReadOnlyContext);

export default ReadOnlyContext; 